export default __webpack_public_path__ + "static/media/paypal.11d40e3b.svg";